import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns, TableDefaultFetchValues } from '../../configuration';
import * as PaymentSelectors from '../../../../redux/reducers/payment_list_reducer/selectors';
import { useDispatch } from 'react-redux';
import PaymentActions from '../../../../redux/reducers/payment_list_reducer/actions';
import { Box } from '@material-ui/core';
import Filter from '../filter';
import useQuery from 'custom_hooks/useQuery';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles } from 'config';

export default function DatatableList() {
  const ROLE = AuthSelectors.useSelectUserRole();

  const result = PaymentSelectors.useGetPaymentList();
  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(
    TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY
  );
  const sortType = React.useRef<'asc' | 'desc'>(
    TableDefaultFetchValues.TABLE_DEFAULT_ORDER
  );

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const schemeType = query.get('schemeType');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(schemeType && { schemeType }),
  };

  return (
    <Box display="flex" flexDirection="column">
      {(ROLE === AuthRoles.Agent || ROLE === AuthRoles.Admin) && (
        <Filter vat_number={vat_num} schemeType={schemeType} role={ROLE} />
      )}

      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            PaymentActions.setPaymentsAction({
              sortField: _sortField,
              page: selectedPage,
              pageSize: pageSize,
              order: order,
              ...searchParams,
            })
          );
        }}
      />
    </Box>
  );
}
